import { render, staticRenderFns } from "./VirtualAccountBLPaymentPop.vue?vue&type=template&id=29a77e36"
import script from "./VirtualAccountBLPaymentPop.vue?vue&type=script&lang=js"
export * from "./VirtualAccountBLPaymentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a77e36')) {
      api.createRecord('29a77e36', component.options)
    } else {
      api.reload('29a77e36', component.options)
    }
    module.hot.accept("./VirtualAccountBLPaymentPop.vue?vue&type=template&id=29a77e36", function () {
      api.rerender('29a77e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/VirtualAccountBLPaymentPop.vue"
export default component.exports